import { TextField, Typography } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import InputLabel from "@material-ui/core/InputLabel";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import AddRowButton from "components/common/AddRowButton";
import ColorButton from "components/common/ColorButton";
import ContentTitle from "components/common/ContentTitle";
import Steper from "components/common/Steper";
import ButtonController from "components/request-document/components/ButtonController";
import {
    Bagde,
    StyleCheckbox,
    StyledTableCell,
    TableRowHead,
    useStyles
} from "components/request-document/components/Commons";
import { useFormik } from "formik";
import {
    REQUEST_DOCUMENT_STEP,
    RoleId,
    STATUS_PROCESS
} from "libs/configs/constant";
import { SMART_T_STEP } from "libs/constant/Step";
import useModalLoading from "libs/hooks/useModalLoading";
import { getDefaultRow, getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash-es";
import { React, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { getMasterData } from "redux/modules/masterSlice";
import { selectPersonalDetail } from "redux/modules/personalSlice";
import { setSmartFormStep } from "redux/modules/uiSlice";
import {
    addSmartForm,
    addSmartFormSlice,
    getSmartForm,
    getSmartFormFieldConfig,
    selectAddSmartForm,
    selectCurrentSmartForm,
    selectCurrentSmartServiceId,
    selectDraftId,
    selectSmartFormFieldConfig
} from "redux/modules/visaForm";
import * as yup from "yup";

export default function UserProfileStepC() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { showLoading, hideLoading } = useModalLoading();
  const [isSaveDraft, setSaveDraft] = useState(false);
  const canEdit = useSelector(canEditForm);
  const personalDetail = useSelector(selectPersonalDetail);
  const smartServiceId = useSelector(selectCurrentSmartServiceId);
  const draftId = useSelector(selectDraftId);
  const smartFormFieldConfig = useSelector(selectSmartFormFieldConfig);
  const addSmartFormState = useSelector(selectAddSmartForm);
  const smartform = useSelector(selectCurrentSmartForm);

  const smartNameById = (p, c) => ({ ...p, [c.smartName]: c });

  const personalId = get(personalDetail, "personalID", "");

  const detailList = [
    "DirectInvestmentTechnology",
    "Investmentthrough",
    "DirectInvestmentStartup",
    "Companies",
  ];
  const detail = get(smartform, "detail", [])
    .filter((field) => detailList.includes(field.smartName))
    .reduce(smartNameById, {});

  useEffect(() => {
    dispatch(
      getMasterData({
        CountryConfig: true,
        CityConfig: true,
        VisaTypeConfig: true,
        theImmigrationBureauConfig: true,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    if (smartServiceId) {
      dispatch(getSmartFormFieldConfig({ smartserviceId: smartServiceId }));
      dispatch(
        getSmartForm({
          smartserviceId: smartServiceId,
          draftId,
          personalId,
        })
      );
    }
  }, [dispatch, draftId, personalId, smartServiceId]);

  useEffect(() => {
    if (!addSmartFormState.isLoading) {
      if (addSmartFormState.isSuccess) {
        hideLoading();
        dispatch(addSmartFormSlice.actions.clearAsyncState());
        if (!isSaveDraft) {
          dispatch(setSmartFormStep(SMART_T_STEP.PART_C));
        } else {
          dispatch(
            getSmartForm({
              smartserviceId: smartServiceId,
              draftId,
              personalId,
            })
          );
        }
      } else if (addSmartFormState.isFailure) {
        hideLoading();
        alert(addSmartFormState.error?.message);
        dispatch(addSmartFormSlice.actions.clearAsyncState());
      }
    }
  }, [
    addSmartFormState,
    dispatch,
    draftId,
    hideLoading,
    isSaveDraft,
    personalId,
    smartServiceId,
  ]);

  const callAPISubmit = async (values) => {
    showLoading();
    const { visaissuance, ...restValues } = values;

    const defaultType = get(smartFormFieldConfig, "data.defaultType", []);
    const documentFields = Object.keys(restValues);
    const getFieldListConfig = defaultType.filter((field) =>
      documentFields.includes(field.smartName)
    );

    const getValue = (field) => {
      switch (field.smartName) {
        case "Companies": {
          const companies = get(values, field.smartName, []);
          const value = companies.filter((v) => !!v.CompanyName);
          return value || null;
        }
        default:
          return get(values, `${field.smartName}`, null);
      }
    };

    const getSmartId = (field) =>
      get(detail, `${field.smartName}.smartId`, null);

    const prepareData = {
      draftId: draftId || null,
      smartserviceId: smartServiceId,
      personalId: personalId,
      survey: null,
      visaissuance: visaissuance,
      detail: getFieldListConfig.map((field) => ({
        smartName: field.smartName,
        smartId: getSmartId(field),
        partfromId: field.partfromId,
        configsmartId: field.configsmartId,
        linkTable: field.linkTable,
        value: getValue(field),
      })),
    };

    await dispatch(
      addSmartForm({
        data: prepareData,
      })
    );
  };

  const defaultCompanies = {
    companiesId: null,
    companyName: null,
    valueofShares: null,
    amountOfConvertibledebt: null,
    status: true,
  };
  const mapCompanies = (value) => ({
    companiesId: value.companiesId,
    CompanyName: value.companyName,
    ValueofShares: value.valueofShares,
    AmountOfConvertibledebt: value.amountOfConvertibledebt,
    Status: value.status,
  });

  const validationSchema = yup.object({});
  const isDraftDocument = smartform?.statausID === STATUS_PROCESS.Draft;
  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: isDraftDocument ? validationSchema : yup.object({}),
    initialValues: {
      DirectInvestmentTechnology:
        get(detail, "DirectInvestmentTechnology.value", "False") === "True",
      Investmentthrough:
        get(detail, "Investmentthrough.value", "False") === "True",
      DirectInvestmentStartup:
        get(detail, "DirectInvestmentStartup.value", "False") === "True",
      Companies: getDefaultRow(detail, "Companies.value", defaultCompanies).map(
        mapCompanies
      ),
      // visaissuance: {
      //   visaInssuanceId: get(smartform, "visaissuance.visaInssuanceId", null),
      //   overseas: get(smartform, "visaissuance.overseas", true),
      //   countryId: get(smartform, "visaissuance.countryId", ""),
      //   cityId: get(smartform, "visaissuance.cityId", ""),
      //   thailand: get(smartform, "visaissuance.thailand", false),
      //   theImmigrationBureauID: get(
      //     smartform,
      //     "visaissuance.theImmigrationBureauID",
      //     null
      //   ),
      //   oneStopService: get(smartform, "visaissuance.oneStopService", false),
      //   eec: get(smartform, "visaissuance.eec", false),
      //   visaTypeId: get(smartform, "visaissuance.visaTypeId", ""),
      //   visaExp: get(smartform, "visaissuance.visaExp", ""),
      // },
    },
    onSubmit: async (values) => {
      setSaveDraft(false);
      callAPISubmit(values);
    },
  });
  const Role = useSelector((e) => {
    return e.user.profile.roleId;
  });
  // Disabled all field if status != draft
  if (!isDraftDocument && Role !== RoleId.Admin) {
    formik.handleBlur = () => {};
    formik.handleChange = () => {};
    formik.setFieldValue = () => {};
  }

  const Companies = formik.values.Companies;

  return (
    <div className={classes.root}>
      <form onSubmit={formik.handleSubmit}>
        <ContentTitle
          title="Application Form"
          subTitle="APPLICATION FOR QUALIFICATION ENDORSEMENT FOR SMART VISA “I”"
        />
        <Steper currentStep={1} stepInfo={REQUEST_DOCUMENT_STEP} />
        <TableContainer style={{ marginTop: 35, borderRadius: 4 }}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={4}>
                  <Typography variant="h6" className={classes.tableTitle}>
                    Part B: Investment in Thailand
                  </Typography>
                </StyledTableCell>
              </TableRow>
            </TableHead>

            <TableRow>
              <StyledTableCell colSpan={4}>
                <div className={classes.cellContent}>
                  <Bagde number={1} />
                  <div className={classes.wrapField}>
                    <InputLabel>
                      1. Please select all types of your investment.
                    </InputLabel>

                    <div className={classes.wrapField} style={{ marginTop: 8 }}>
                      <FormGroup row>
                        <FormControlLabel
                          control={
                            <StyleCheckbox
                              disabled={!canEdit}
                              name="DirectInvestmentTechnology"
                              value={formik.values.DirectInvestmentTechnology}
                              checked={Boolean(
                                formik.values.DirectInvestmentTechnology
                              )}
                              onClick={() => {
                                formik.setFieldValue(
                                  "DirectInvestmentTechnology",
                                  !formik.values.DirectInvestmentTechnology
                                );
                              }}
                            />
                          }
                          label="Direct investment in technology-based business in Thailand"
                        />
                        <FormControlLabel
                          control={
                            <StyleCheckbox
                              disabled={!canEdit}
                              name="Investmentthrough"
                              value={formik.values.Investmentthrough}
                              checked={Boolean(formik.values.Investmentthrough)}
                              onClick={() => {
                                formik.setFieldValue(
                                  "Investmentthrough",
                                  !formik.values.Investmentthrough
                                );
                              }}
                            />
                          }
                          label="Investment through a venture capital company which has invested technology-based business in Thailand"
                        />
                        <FormControlLabel
                          control={
                            <StyleCheckbox
                              disabled={!canEdit}
                              name="DirectInvestmentStartup"
                              value={formik.values.DirectInvestmentStartup}
                              checked={Boolean(
                                formik.values.DirectInvestmentStartup
                              )}
                              onClick={() => {
                                formik.setFieldValue(
                                  "DirectInvestmentStartup",
                                  !formik.values.DirectInvestmentStartup
                                );
                              }}
                            />
                          }
                          label="Direct investment in a startup or an incubation or accelerator business in Thailand"
                        />
                      </FormGroup>
                    </div>
                  </div>
                </div>
              </StyledTableCell>
            </TableRow>

            <TableHead>
              <TableRow>
                <StyledTableCell colSpan={4}>
                  <div className={classes.cellContent}>
                    <Bagde number={2} />
                    <div className={classes.wrapField}>
                      <Typography variant="h6" className={classes.tableTitle}>
                        List of companies in which the applicant has invested in
                      </Typography>
                    </div>
                  </div>
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableRowHead>
              <StyledTableCell align="center">
                <InputLabel>Company Name</InputLabel>
              </StyledTableCell>
              <StyledTableCell align="center">
                <InputLabel>Value of shares (Baht)</InputLabel>
              </StyledTableCell>
              <StyledTableCell align="center">
                <InputLabel>Amount of convertible debt (Baht)</InputLabel>
              </StyledTableCell>
              <StyledTableCell align="center" />
            </TableRowHead>

            {Companies.map((companies, index) => {
              if (!companies.Status) return null;
              return (
                <TableRow key={companies.companiesId + "-" + index}>
                  <StyledTableCell>
                    <TextField
                      disabled={!canEdit}
                      className={classes.textField}
                      variant="outlined"
                      name={`Companies[${index}].CompanyName`}
                      value={companies.CompanyName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={isError(`Companies[${index}].CompanyName`, formik)}
                      helperText={getErrorMessage(
                        `Companies[${index}].CompanyName`,
                        formik
                      )}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <TextField
                      disabled={!canEdit}
                      className={classes.textField}
                      variant="outlined"
                      type="number"
                      name={`Companies[${index}].ValueofShares`}
                      value={companies.ValueofShares}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={isError(
                        `Companies[${index}].ValueofShares`,
                        formik
                      )}
                      helperText={getErrorMessage(
                        `Companies[${index}].ValueofShares`,
                        formik
                      )}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <TextField
                      disabled={!canEdit}
                      className={classes.textField}
                      variant="outlined"
                      type="number"
                      name={`Companies[${index}].AmountOfConvertibledebt`}
                      value={companies.AmountOfConvertibledebt}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={isError(
                        `Companies[${index}].AmountOfConvertibledebt`,
                        formik
                      )}
                      helperText={getErrorMessage(
                        `Companies[${index}].AmountOfConvertibledebt`,
                        formik
                      )}
                    />
                  </StyledTableCell>

                  <StyledTableCell align="center" style={{ width: 100 }}>
                    {index === 0 ? (
                      <div style={{ width: 82 }} />
                    ) : (
                      <>
                        <ColorButton
                          disabled={!canEdit}
                          fullWidth={false}
                          style={{ width: 82, fontWeight: "bold" }}
                          variant="contained"
                          color="error"
                          size="small"
                          onClick={() => {
                            if (companies.companiesId) {
                              formik.setFieldValue(
                                `Companies[${index}].Status`,
                                false
                              );
                            } else {
                              formik.setFieldValue(
                                "Companies",
                                Companies.filter((__, i) => i !== index)
                              );
                            }
                          }}
                        >
                          Remove
                        </ColorButton>
                      </>
                    )}
                  </StyledTableCell>
                </TableRow>
              );
            })}

            <TableRow>
              <StyledTableCell colSpan={4}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <AddRowButton
                    disabled={!canEdit}
                    onClick={() => {
                      formik.setFieldValue("Companies", [
                        ...Companies,
                        mapCompanies(defaultCompanies),
                      ]);
                    }}
                  />
                </div>
              </StyledTableCell>
            </TableRow>

            {/* <VisaIssuanceSection colSpan={4} formik={formik} /> */}
          </Table>
        </TableContainer>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            padding: "21px 50px",
          }}
        >
          <b>
            I hereby certify that the information and the evidence provided is
            true and complete in all respects. If there are any false statements
            which are considered perjury, I agree to be subjected to any
            applicable legal prosecution.
          </b>
        </div>

        <ButtonController
          onClickSaveDraft={() => {
            if (!canEdit) {
              dispatch(setSmartFormStep(SMART_T_STEP.PART_C));
              return;
            }
            setSaveDraft(true);
            callAPISubmit(formik.values);
          }}
        />
      </form>
    </div>
  );
}
